// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"home-page_wrapper__PL0U7","main":"home-page_main__27ZK8","map":"home-page_map__36d3_","detail":"home-page_detail__2NVuG"};